import dialogBox from '../../dialogBox/index.vue';
export default {
  components: {
    dialogBox
  },
  props: {
    bg: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    bgHeight: {
      type: Number,
      default: 388
    },
    bgWidth: {
      type: Number,
      default: 353
    }
  },
  computed: {
    styleBg() {
      const styleObj = {
        height: `${this.bgHeight}px`,
        width: `${this.bgWidth}px`,
        'background-image': `url('${this.bg}')`
      };
      return styleObj;
    }
  },
  methods: {
    closeBtn() {
      this.$emit('close-task-dialog');
    },
    clickContent() {
      this.$emit('click-content');
    }
  }
};